import React, { Component } from 'react';
import { Pagination, Form, Input, Button, Table, DatePicker } from 'antd';
import { Select, ConfigProvider, Icon, Breadcrumb, Tag, Popover } from 'antd';
import { Checkbox } from 'antd';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import { apis } from '../api/index.js';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';
import moment from 'moment';
import i18n from 'i18next';
import ConnectedMenu from '../connectedComponents/ConnectedMenu.js';
import TableEmpty from '../components/TableEmpty.js';
import { getSex, subscribeLocalStorage, formatDA } from '../utils';
import { formatFromTime, formatToTime, getDay, breadBack } from '../utils';
import { changeListWidth, getInstitutionOptions, setScrollTop } from '../utils';
import { getProvinceOption, institutionRecord, getArea } from '../utils';
import { calcTableHeight, showMoreSearch, fastDateOption } from '../utils';
import { breadItem, setSearchInfo, loadingOptionsHtml } from '../utils';
import { autoFresh, timeCalc } from '../utils';
import cloneDeep from 'lodash.clonedeep';

import throttle from 'lodash.throttle';
const { Option } = Select;
let autoRefreshReview = '';

const initState = {
  pageNum: 1,
  patName: '',
  defineTimeType: false,
  recentDays: 2,
  chestPa: undefined,
  areaProvince: undefined,
  institutionId: undefined,
  status: undefined,
  dayRange: [getDay(-2) + ' 0:0:0', getDay(0) + ' 23:59:59'],
  timeTypeVal: false,
  reviewCode: undefined,
};

class IntelligentScreening extends Component {
  static propTypes = {
    form: PropTypes.object,
    server: PropTypes.object,
    history: PropTypes.object,
    onUserInfoUpdated: PropTypes.func,
    setApplicationData: PropTypes.func,
    setCurrentSearchInfoData: PropTypes.func,
    match: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.state = initState;

    this.throttledList = throttle(newState => {
      this.getList(newState);
    }, 1000);

    this.formResize = throttle(newState => {
      //页面大小改变，更新table高度
      const newHeight = calcTableHeight(189) || 0;
      const showMore = showMoreSearch();
      this.setState({ showMoreFilter: showMore, tableHeight: newHeight });
    }, 1000);
  }

  async componentDidMount() {
    const roleInfo = window.store.getState().api.user.info.operationAuths || '';
    const isAnonymity = roleInfo.indexOf('S') >= 0;
    this.setState({
      isAnonymity,
      tableHeight: 0,
      list: [],
      total: 0,
      autoRefreshStatus: false,
      loadingIconShow: false,
      searchLoading: false,
      listWidth: 'calc(87% - 8px)',
      moreFilter: true,
      showMoreFilter: false,
    });

    this.getProvinceList();
    this.getInstitutionData();
    subscribeLocalStorage(this.throttledList);
    this.pageInit();
    let _this = this;
    window.addEventListener('resize', () => _this.formResize());
    this.formResize();
    this.getTubeReviewDict();
  }

  pageInit = () => {
    const api = window.store.getState().api;
    const searchInfo = api.current.searchInfo;
    let state = searchInfo.intelligentscreening;
    state.defineTimeType = state.timeTypeVal;
    const newState = Object.assign({}, initState, state);
    this.throttledList(newState);

    //从内在中读取是否开启自动刷新
    api.current.searchInfo = api.current.searchInfo || {};
    const status = api.current.searchInfo.autoRefreshStatus || false;
    this.reFreshList(status);
  };

  //自动刷新列表
  reFreshList = status => {
    this.setState({ autoRefreshStatus: status });
    const _this = this;
    if (status) {
      autoRefreshReview = setInterval(function() {
        if (!document.getElementById('IntelligentScreening'))
          clearInterval(autoRefreshReview);
        else _this.throttledList();
      }, 10000);
    } else clearInterval(autoRefreshReview);
  };

  //获取列表
  getList = newState => {
    const rows = 20;
    const updatedState = Object.assign({}, this.state, newState);
    this.setState(updatedState);
    const oldState = cloneDeep(updatedState);
    const post = {
      pageNum: updatedState.pageNum,
      pageSize: rows,
      chestPa: updatedState.chestPa,
      areaProvince: updatedState.areaProvince,
      institutionId: updatedState.institutionId,
      patName: updatedState.patName,
      // reviewCode: updatedState.reviewCode,
    };
    if (updatedState.defineTimeType) {
      if (updatedState.dayRange) {
        post.fromTime = formatFromTime(updatedState.dayRange);
        post.toTime = formatToTime(updatedState.dayRange);
      } else {
        post.fromTime = undefined;
        post.toTime = undefined;
      }
    } else {
      if (updatedState.recentDays !== undefined) {
        const dayRange = timeCalc(updatedState.recentDays);
        post.fromTime = dayRange.fromTime;
        post.toTime = dayRange.toTime;
      } else {
        post.fromTime = undefined;
        post.toTime = undefined;
      }
    }
    let reviewCode = oldState.reviewCode || [];
    const indexM1 = reviewCode.indexOf('-1');
    if (indexM1 > -1) {
      post.state = [10, 20];
      reviewCode.splice(indexM1, 1);
    }

    const index0 = reviewCode.indexOf('0');
    if (index0 > -1) {
      post.imageResult = '0';
      reviewCode.splice(index0, 1);
    }
    post.reviewCode = reviewCode;
    apis.tubeStudyApplyList(post).then(result => {
      this.setState({ loadingIconShow: false, searchLoading: false });
      if (result.code === '0') {
        this.setState({ list: result.data.list, total: result.data.total });
      } else {
        if (result.code === '1009') this.props.history.push('/login');
        this.setState({ list: [], total: 0 });
      }
    });
  };

  //查看详情
  viewHeatmap = item => {
    item.subVos = item.dicomList;
    this.props.setApplicationData(item);

    const xpwidth = window.screen.width - 10;
    const xpheight = window.screen.height - 105;

    const studyUid = item.studyUid;
    let url = `/viewer/study/${studyUid}?tubeId=${item.id}&from=screening&from1=view`;
    const str = `scrollbars=yes,resizable=1,modal=false,alwaysRaised=yes,width=${xpwidth},height=${xpheight}`;
    window.open(url, 'viewer', str);
  };

  //点击搜索按钮
  handleSearch = e => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        const newState = {
          patName: values.patName,
          chestPa: values.chestStatus,
          areaProvince: values.provice,
          institutionId: (values.name || []).join(','),
          pageNum: 1,
          loadingIconShow: true,
          searchLoading: true,
          status: values.status,
          dayRange: values.dayRange,
          recentDays: values.recentDays,
          defineTimeType: this.state.timeTypeVal,
          timeTypeVal: this.state.timeTypeVal,
          reviewCode: values.status,
        };
        this.throttledList(newState);
        setSearchInfo(newState, 'intelligentscreening', this);
        setScrollTop();
      }
    });
  };

  //点击重置按钮
  handleReset = () => {
    const loadingState = { searchLoading: true };
    const newState = Object.assign({}, initState, loadingState);
    this.setState(newState);
    this.props.form.resetFields();
    this.getInstitutionData();
    this.throttledList(newState);
    setSearchInfo(initState, 'intelligentscreening', this);
    setScrollTop();
  };

  //获取是否是正位胸片
  getChestPa = record => {
    const dicomList = record.dicomList || [];
    let [html, chestPa, value, otherPart] = [[], false, 0, false];
    dicomList.forEach(item => {
      if (item.chestPa) {
        chestPa = true;
        if (value < item.confidence) {
          value = (parseFloat(item.confidence) * 100).toFixed(1);
        }
      } else otherPart = true;
    });
    if (chestPa)
      html.push(
        <Option key={0} value="chestPa">
          正位胸片
        </Option>
      );
    if (otherPart)
      html.push(
        <Option key={1} value="other">
          其他部位
        </Option>
      );
    if (html.length === 1 && chestPa)
      html = <span className="text-tag-chestpa">正位胸片</span>;
    else if (html.length === 1 && otherPart)
      html = <span className="text-tag-other">其他部位</span>;
    return { html, len: html.length };
  };

  //分页
  pageOnChange = (pageNum, pageSize) => {
    setScrollTop();
    const newState = { pageNum, searchLoading: true };
    this.throttledList(newState);
  };

  //获取机构列表
  getInstitutionData = async (name, area) => {
    const data = await institutionRecord(name, area);
    this.setState({ institutionData: data });
  };

  //机构下拉的查询功能
  handleInstitutionSearch = value => {
    const area = this.state.areaProvince;
    this.getInstitutionData(value, area);
  };

  getReviewedStatusDetail = (status, chestPa) => {
    const statusArray = [
      { value: '0', label: '结核影像阴性', color: '#87D067' },
      { value: '1', label: '结核影像阳性', color: '#FF5605' },
      { value: '2', label: '待诊断', color: '#E6CD00' },
    ];
    let tagHtml;

    if (chestPa !== 1) {
      return <span>--</span>;
    } else {
      statusArray.forEach(item => {
        if (item.value === status)
          tagHtml = <Tag color={item.color}>{item.label}</Tag>;
      });
    }
    return tagHtml;
  };

  handleChangeSelect = (key, value) => {
    const newData = [...this.state.list];
    const index = newData.findIndex(item => key === item.id);
    if (index > -1) {
      const changedData = newData[index];
      changedData.part = value;
      newData[index] = changedData;
      this.setState({ list: newData });
    }
  };

  getTubeReviewDict = () => {
    apis.tubeReviewDict().then(res => {
      if (res.code === '0') {
        const stateArray = [{ name: '待诊断', code: '-1' }];
        const result = stateArray.concat(res.data);
        this.setState({ tubeDict: result });
      }
    });
  };
  getTubeReviewOption = () => {
    const { tubeDict = [] } = this.state;
    return tubeDict.map((item, index) => (
      <Option key={index} value={item.code} title={item.name}>
        {item.name}
      </Option>
    ));
  };

  getColumns = () => {
    const { isAnonymity } = this.state;
    let isBig = false;
    const screenWidth = document.body.clientWidth * 0.87 - 55;
    if (screenWidth > 1200) isBig = true;
    const columns = [
      {
        title: '姓名',
        dataIndex: 'patName',
        key: 'patName',
        width: isBig ? 200 : 170,
        render: patName => (isAnonymity ? '***' : patName),
      },
      {
        title: '年龄',
        dataIndex: 'patAge',
        key: 'patAge',
        width: isBig ? 120 : 100,
        render: patAge => (isAnonymity ? '***' : patAge),
      },
      {
        title: '性别',
        dataIndex: 'patSex',
        key: 'patSex',
        width: isBig ? 120 : 100,
        render: patSex => (isAnonymity ? '***' : getSex(patSex)),
      },
      {
        title: '部位',
        dataIndex: '',
        key: 'chestPa',
        width: isBig ? 150 : 120,
        render: (record, index) => {
          record.dicomList = record.dicomList || [];
          const chestPaTrue = record.dicomList.filter(
            item => item.chestPa === true
          );
          const defaultValue = chestPaTrue.length > 0 ? 'chestPa' : 'other';
          record.part = record.part || defaultValue;

          const result = this.getChestPa(record, index);
          return (
            <div>
              {record.dicomList.length > 0 ? (
                result.len === 2 ? (
                  <Select
                    size="small"
                    onChange={this.handleChangeSelect.bind(this, record.id)}
                    defaultValue={defaultValue}
                    value={record.part}
                    style={{ width: 90 }}
                    getPopupContainer={triggerNode => triggerNode.parentNode}
                  >
                    {result.html}
                  </Select>
                ) : (
                  result.html
                )
              ) : (
                '--'
              )}
            </div>
          );
        },
      },
      {
        title: '肺结核筛查',
        dataIndex: '',
        key: 'imageResult',
        width: 180,
        render: record => {
          record.dicomList = record.dicomList || [];
          const chestPaTrue = record.dicomList.filter(
            item => item.chestPa === true
          );
          let html = '';
          if (chestPaTrue.length > 0 && record.part === 'chestPa') {
            if (record.imageResult === 1) {
              html = (
                <Popover
                  placement="bottomLeft"
                  content={record.reviewText}
                  title={i18n.t('impressionR')}
                >
                  <Tag color="#FF5605">结核影像阳性</Tag>
                </Popover>
              );
            } else if (record.imageResult === 0) {
              html = <Tag color="#87D067">结核影像阴性</Tag>;
            } else {
              html = <Tag color="#E6CD00">待诊断</Tag>;
            }
          } else {
            html = <span>--</span>;
          }
          return <div>{html}</div>;
        },
      },
      {
        title: '上传时间',
        dataIndex: 'createTime',
        key: 'createTime',
        width: isBig ? 220 : 180,
        render: createTime => <span>{formatDA(createTime)}</span>,
      },
      {
        title: '机构',
        dataIndex: 'institutionName',
        key: 'institutionName',
        render: value => <span>{isAnonymity ? '***' : value}</span>,
      },
      {
        title: '操作',
        dataIndex: '',
        key: 'id',
        align: 'center',
        width: 150,
        fixed: 'right',
        render: record => {
          record.dicomList = record.dicomList || [];
          const chestPaTrue = record.dicomList.filter(
            item => item.chestPa === true
          );
          return (
            <Button
              type="link"
              key={0}
              className="btn-viewdetail"
              disabled={chestPaTrue.length === 0}
              onClick={this.viewHeatmap.bind(this, record)}
            >
              <Icon type="eye" theme="filled" />
              查看
            </Button>
          );
        },
      },
    ];
    return columns;
  };

  handleChangeProvince = value => {
    this.setState({ areaProvince: value });
    this.getInstitutionData('', value);
  };
  // 获取省份列表
  getProvinceList = async () => {
    const data = await getArea(0);
    this.setState({ provinceList: data });
  };
  setTimeType = e => {
    this.setState({ timeTypeVal: e.target.checked });
  };
  setFreshEvent = e => {
    // if (e.target.checked) this.setSearchEvent('ns-062');
    // else this.setSearchEvent('ns-063');
  };
  setBackEvent = () => {
    // this.setSearchEvent('ns-066');
  };
  render() {
    let { list, institutionData, timeTypeVal, isAnonymity } = this.state;
    let { tableHeight, recentDays, areaProvince, institutionId } = this.state;
    let { patName, chestPa, status, dayRange } = this.state;
    const { moreFilter, showMoreFilter } = this.state;
    institutionId = institutionId ? institutionId.split(',') : [];
    institutionId = institutionId.map(item => +item);

    const { RangePicker } = DatePicker;
    const dateFormat = 'YYYY-MM-DD';

    const columns = this.getColumns();

    const { getFieldDecorator } = this.props.form;
    const institutionOptions = getInstitutionOptions(institutionData, 'id');

    const loadingOptions = loadingOptionsHtml(this.state.searchLoading);

    let tableWidth = 1200;
    const screenWidth = document.body.clientWidth * 0.87 - 55;
    if (screenWidth > tableWidth) tableWidth = screenWidth;

    const from = formatFromTime(dayRange);
    const to = formatToTime(dayRange);
    return (
      <div className="form-bg" id="IntelligentScreening">
        <ConnectedMenu toggleCollapsed={() => changeListWidth(this)} />
        <div className="theme-content">
          <ConnectedHeader
            toggleCollapsed={() => changeListWidth(this)}
            login={false}
            home={true}
          />
          <div className="theme-box">
            <div className="bread-crumb">
              <Breadcrumb>{breadItem(['智能筛查', '肺结核筛查'])}</Breadcrumb>

              {breadBack(this)}
              {autoFresh(this)}
            </div>

            <div className="box" style={{ width: this.state.listWidth }}>
              <div className="left">
                <Form
                  className={`ant-advanced-search-form${
                    !moreFilter && showMoreFilter ? ' notOverflow' : ''
                  }`}
                  onSubmit={this.handleSearch}
                  layout="inline"
                >
                  <div className="searchBox">
                    <div className="searchBoxContent">
                      <div className="search-unit">
                        <Form.Item
                          style={{
                            display: timeTypeVal === true ? '' : 'none',
                          }}
                          label="上传时间"
                          colon={false}
                        >
                          <ConfigProvider locale={zh_CN}>
                            {getFieldDecorator('dayRange', {
                              initialValue:
                                from && to
                                  ? [
                                      moment(from, dateFormat),
                                      moment(to, dateFormat),
                                    ]
                                  : null,
                            })(
                              <RangePicker
                                format={dateFormat}
                                placeholder={['开始时间', '结束时间']}
                                style={{ width: 240 }}
                              />
                            )}
                          </ConfigProvider>
                        </Form.Item>
                        <Form.Item
                          style={{
                            display: timeTypeVal === true ? 'none' : '',
                          }}
                          label="上传时间"
                          colon={false}
                        >
                          {getFieldDecorator('recentDays', {
                            initialValue: recentDays,
                          })(
                            <Select
                              defaultActiveFirstOption={true}
                              showArrow={false}
                              filterOption={false}
                              allowClear={true}
                              style={{ width: 240 }}
                            >
                              {fastDateOption()}
                            </Select>
                          )}
                        </Form.Item>
                        <Form.Item label="" colon={false}>
                          {getFieldDecorator('defineTimeType', {})(
                            <Checkbox
                              checked={timeTypeVal}
                              onChange={this.setTimeType}
                            >
                              自定义
                            </Checkbox>
                          )}
                        </Form.Item>
                      </div>
                      <div className="search-unit">
                        <Form.Item
                          label="机构"
                          colon={false}
                          className="form-provice"
                        >
                          {getFieldDecorator('provice', {
                            initialValue: areaProvince,
                          })(
                            <Select
                              showSearch
                              placeholder="选择省份"
                              defaultActiveFirstOption={false}
                              filterOption={false}
                              showArrow={false}
                              onChange={this.handleChangeProvince}
                              notFoundContent={null}
                              allowClear={true}
                              style={{ width: 150 }}
                              disabled={isAnonymity}
                            >
                              {getProvinceOption(this.state.provinceList)}
                            </Select>
                          )}
                        </Form.Item>

                        <Form.Item
                          label=""
                          colon={false}
                          className="form-institute"
                        >
                          {getFieldDecorator('name', {
                            initialValue: institutionId,
                          })(
                            <Select
                              className="institution-selection"
                              showSearch
                              mode="multiple"
                              placeholder="请输入机构名称"
                              defaultActiveFirstOption={false}
                              showArrow={false}
                              filterOption={false}
                              onSearch={this.handleInstitutionSearch}
                              onChange={this.handleChange}
                              allowClear={true}
                              style={{ width: 220 }}
                              disabled={isAnonymity}
                            >
                              {institutionOptions}
                            </Select>
                          )}
                        </Form.Item>
                      </div>
                      <Form.Item label="部位" colon={false}>
                        {getFieldDecorator('chestStatus', {
                          initialValue: chestPa,
                        })(
                          <Select
                            allowClear={true}
                            placeholder="部位"
                            style={{ width: 160 }}
                          >
                            <Option value="true">正位胸片</Option>
                            <Option value="false">其他部位</Option>
                          </Select>
                        )}
                      </Form.Item>
                      <Form.Item label="姓名" colon={false}>
                        {getFieldDecorator('patName', {
                          initialValue: patName,
                        })(
                          <Input
                            allowClear={true}
                            style={{ width: 160 }}
                            placeholder="请输入患者姓名"
                            disabled={isAnonymity}
                          />
                        )}
                      </Form.Item>
                      <Form.Item label="肺结核筛查" colon={false}>
                        {getFieldDecorator('status', {
                          initialValue: status,
                        })(
                          <Select
                            className="institution-selection"
                            placeholder="请选择筛查结果"
                            allowClear={true}
                            style={{ width: 160 }}
                            mode="multiple"
                            dropdownMatchSelectWidth={false}
                          >
                            {this.getTubeReviewOption()}
                          </Select>
                        )}
                      </Form.Item>
                    </div>
                  </div>
                  <div className="searchOptBox">
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="btn-search"
                        disabled={this.state.searchLoading}
                      >
                        {this.state.loadingIconShow ? (
                          <Icon type="sync" spin />
                        ) : (
                          <Icon type="search" />
                        )}
                        搜索
                      </Button>
                      <Button
                        style={{ marginLeft: 8 }}
                        icon="redo"
                        className="btn-reset"
                        disabled={this.state.searchLoading}
                        onClick={this.handleReset}
                      >
                        重置
                      </Button>
                    </Form.Item>
                    {this.state.showMoreFilter && (
                      <Button
                        type="link"
                        className="moreFilter"
                        onClick={() => {
                          this.setState({ moreFilter: !moreFilter });
                        }}
                        icon={moreFilter ? 'down' : 'up'}
                      >
                        {moreFilter ? '展开' : '收起'}
                      </Button>
                    )}
                  </div>
                </Form>
                <div className="history-list">
                  <Table
                    loading={loadingOptions}
                    columns={columns}
                    dataSource={list}
                    rowKey={record => record.id}
                    key={record => record.id}
                    pagination={false}
                    className="list-item"
                    scroll={{ y: tableHeight, x: tableWidth }}
                    locale={{ emptyText: <TableEmpty /> }}
                  />
                  <ConfigProvider locale={zh_CN}>
                    <Pagination
                      onChange={this.pageOnChange}
                      total={this.state.total}
                      pageSize={20}
                      className="list-page"
                      current={this.state.pageNum}
                      showQuickJumper
                      size="small"
                      showTotal={() => `共${this.state.total}条`}
                    ></Pagination>
                  </ConfigProvider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Form.create()(IntelligentScreening));
